import { useContext } from "react";
import { AppContext, AppContextValue } from "../contexts/app-context";

export const useAppContext = (): AppContextValue => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within a App Context Provider");
  }
  return context;
};
